import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import { useLocation } from 'react-router-dom';
import { api } from "../../helpers/api";
import { APIINTEGRACION } from "../../helpers/url";
import { EncryptData } from "../../helpers/encrypt";
import { Text, TextColored } from '../../components/typography';
import { ThemeContext } from '../../theming';
import { useOutletContext } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import useWindowDimensions from "../../helpers/useWindowDimensions";
import Progress from "../progress/Progress";
import { Error, Excedente, PCErrorBlack } from "../../assets/icons/dashboard";
import ButtonProgreso from '../buttons/Button'
import Loading from '../loading/Loading';
import { ModalWebPagos } from "../modal/Modal"

import { useNavigate } from 'react-router-dom';

import { Card, Row, Col, Button, Container } from 'react-bootstrap';
import CardResumenPago from '../cards/CardResumenPago';
import { Reload } from '../../assets/icons/login';
import Advertencia from '../../assets/images/advertencia2.png';


function Resumen() {
  //window.jQuery = $;
  const history = useNavigate();
  const { width } = useWindowDimensions();
  const [showModalError, setShowModalError] = useState(false);
  const [modalData, setModalData] = useState({});
  const [dataBloqueo, setDataBloqueo] = useState({});

  const [showLoading, setShowLoading] = useState({ display: 'none' });
  const [formulario, setFormulario] = useState("");
  const { state } = useLocation();
  const [reqTrack, setReqTrack] = useState({
    idOrigenTracking: 2,
    idPasarela: state.xml1.headers.CodigoCanalPago,
    metodo: "POST",
    url: "https://www.servipag.com/BotonPago/BotonPago/Pagar",
    response: "",
    rut : state?.xml1?.headers?.RutCliente,
    tipo : state?.xml1?.publico
  });
  const [ reqSeg, setReqSeg] = useState({
    id_movimiento : 3,
    tipo : state?.xml1?.publico,
    rut_token : state?.xml1?.headers?.RutCliente,
  })
  const icons = {
    cuotas: <Excedente />
  }
  const { rut: cliente } = useOutletContext();
  const app = useContext(ThemeContext);
  const { body10, body25, body32, body12, body28 } = app.theme.font;

  const ButtonTry = ({message})=>{
    return <ButtonProgreso 
                onClick={()=>generarFormulario()} 
                sizeText={1} 
                styleText={{ fontWeight : "600"}}
                >
                  <div className='d-flex nowrap justify-content-center'>
                    <div style={{ marginRight : "8px"}}>
                  Reintentar
                    </div>
                  <Reload />
                  </div>
    </ButtonProgreso>
}
  const handleCloseModalError = () => { setShowModalError(false) };

  const handleShowModalError = () => { setShowModalError(true) }
  const generarFormulario = async () => {
    handleCloseModalError();
    setShowLoading({ display: 'block' });
    try {
    let dataPre = await api.post(APIINTEGRACION.POST.PREXML1 + "/" +state.xml1.publico + "/" +state.xml1.headers.RutCliente);
    let url = APIINTEGRACION.POST.ENVIARXML1;
    let xml1Encrypted = {
        d_n : EncryptData( state.xml1.documentos.Monto.toString(), dataPre.data.data),
        d_c : EncryptData( state.xml1.documentos.FechaVencimiento, dataPre.data.data),
        h_d : EncryptData( state.xml1.headers.CodigoCanalPago.toString(), dataPre.data.data),
        h_n : EncryptData( state.xml1.headers.MontoTotalDeuda, dataPre.data.data),
        h_t : state.xml1.headers.RutCliente,
        h_l : EncryptData( state.xml1.headers.EmailCliente??="", dataPre.data.data),
        h_m : EncryptData( state.xml1.headers.NombreCliente??="", dataPre.data.data),
        s : state.xml1.selected.map(sel=>({
         c_no : EncryptData( sel.nu_operacion.toString(), dataPre.data.data),
         c_nc : EncryptData( sel.nu_cuota.toString(), dataPre.data.data),
         c_ig : EncryptData( sel.id_gasto.toString(), dataPre.data.data),
         c_ic : EncryptData( sel.id_concepto.toString(), dataPre.data.data),
         c_tcc : EncryptData( sel.tx_concepto, dataPre.data.data),
         c_tct : EncryptData( sel.tx_cuota, dataPre.data.data),
         c_mp : EncryptData( sel.mt_total_a_pagar.toString(), dataPre.data.data),
         c_mc : EncryptData( sel.mt_cuota.toString(), dataPre.data.data),
         c_mim : EncryptData( sel.mt_interes_mora.toString(), dataPre.data.data),
         c_mgc : EncryptData( sel.mt_gasto_cobranza.toString(), dataPre.data.data),
         c_fp : EncryptData( sel.fe_pago, dataPre.data.data)
        })),
        p : state.xml1.publico
    }
    
    const { data } = await api.post(url, xml1Encrypted);
    setDataBloqueo({ 
      rut: data.data.rut,
      boleta: data.data.boleta,
      pasarela: state.xml1.headers.CodigoCanalPago,
      xml1Encrypted : xml1Encrypted});
    setFormulario(data.data.xml)
      setReqTrack({
        ...reqTrack,
        idTransaccion: data.data.idtransaccion,
        request: data.data.xml,
        code: "200",
        status: "OK"
      })
      setReqSeg({
        ...reqSeg,
        origen : data.data.origen,
        rut_cliente : data.data.rut,
        boleta : data.data.boleta,
        estado : "OK"
      })
    } catch (error) {
      if(error.response.data.message == "Está intentando pagar una cuota ya pagada"){
        history("/web/bandeja")
      }
      setModalData({
        messageLine: false,
        //title: "Pagar contratos",
        color: "red",
        //subtitle: "Error",
        message: error.response.data.message,
        icon: (
          <>
            <PCErrorBlack />
          </>
        ),
        buttonTry : ()=><ButtonTry message={error.response.data.message}/>
      });
      handleShowModalError();

    } finally {
      setShowLoading({ display: 'none' });
      /* $.getScript("https://malsup.github.io/jquery.form.js",function(data, textstatus){
       $("#formEnviarXML1").ajaxForm({
         url : "https://www.servipag.com/BotonPago/BotonPago/Pagar",
        success : function(data){console.log(data)}
      }); */


    }
  }
/*   const sendForm = () => {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "https://www.servipag.com/BotonPago/BotonPago/Pagar");
    xhr.onload = (e) => console.log(e);
    var formData = new FormData();
    formData.append("xml", formulario);
    xhr.send(formData);
  } */
  const irPagar = (req) => {
    let url = APIINTEGRACION.POST.IRPAGAR;
    try {
      api.post(url, req);
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => generarFormulario(), []);
  return (
    <>
      <Loading estilo={showLoading}></Loading>
      <Row
        className="mt-4"
        style={{ width: width >= 701 ? "87%" : "100%" }}
      >
        <Col>
          <Card>
            <Card.Body>
              <CardResumenPago
                icon={icons.cuotas}
                title='Resumen de Pagos'
                progress={66}
                btnBack={true}
                irPagar={
                  <form id="#formEnviarXML1" method='post'
                    action="https://www.servipag.com/BotonPago/BotonPago/Pagar"
                  >
                    <input hidden name="xml"
                      //value={(new DOMParser()).parseFromString(formulario, "text/xml")}/>
                      value={formulario} />
                    <ButtonProgreso
                      type="submit"
                      className='noprint'
                      sizeText={1}
                      disabled={!(reqTrack.code == "200")}
                      onClick={() => irPagar({ tracking: reqTrack, movimiento : reqSeg, bq: dataBloqueo})}
                    >
                      Ir a Pagar
                    </ButtonProgreso>
                  </form>
                }
              >
                <div className={`d-flex flex-column mt-5 ${width >= 701 ? "w-75" : "w-100"} align-items-center`}>
                  <div className={`d-flex justify-content-between ${width >= 701 ? "w-50" : "w-75"}`}>
                    <Text className='text-justify d-block' size={body25} type='primary' bold>
                      Contratos :
                    </Text>
                    <TextColored className='text-justify' size={body25} type="gray">
                      {[...new Set(state.xml1.selected.map(item => item.nu_operacion))].toString()}
                    </TextColored>
                  </div>
                  <div className={`d-flex justify-content-between ${width >= 701 ? "w-50" : "w-75"}`}>
                    <Text className='text-justify d-block' size={body25} type='primary' bold>
                      Monto Total :
                    </Text>
                    <TextColored className='text-justify' size={body25} type="gray">
                      <NumberFormat
                        value={state.xml1.documentos.Monto}
                        displayType='text'
                        prefix="$"
                        thousandSeparator="."
                        decimalScale={2}
                        decimalSeparator=","
                      />
                    </TextColored>
                  </div>
                  <div className={`d-flex justify-content-between align-items-center mt-2 ${width >= 701 ? "w-50" : "w-75"}`}>
                    <Text className='text-justify d-block' size={body25} type='primary' bold>
                      Medio de Pago Elegido :
                    </Text>
                    {/* <TextColored className='text-justify' size={body25} type="gray">
            {state.medioPagoSelected.name}
              </TextColored> */}
                    <img src={state.medioPagoSelected.logo}
                      alt={state.medioPagoSelected.name}
                      width="40%"
                      style={
                        {
                          border: "1px solid rgb(130, 130, 130)",
                          borderRadius: "5%"
                        }
                      }
                    />
                  </div>
                  {state.medioPagoSelected.tiempo_bloqueo > 0 &&<div className={`d-flex justify-content-center align-items-baseline mt-2 no-wrap ${width >= 701 ? "w-75" : "w-75"}`}>
                    <img src={Advertencia}
                     alt="Advertencia"
                     width="20px"
                     style={{ marginRight : 4}}
                    />
                    <Text className='text-justify d-block' size={body10} type='primary' bold>
                      Las cuotas seleccionadas permanecerán inactivas por {state.medioPagoSelected.tiempo_bloqueo} min o hasta culminar el proceso de pago
                    </Text>
                  </div>}
                  {/* <pre>{JSON.stringify(state)}</pre> */}
                </div>
              </CardResumenPago>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ModalWebPagos
        show={showModalError}
        icon={modalData.icon}
        headerTitle="Pago en Línea"
        messageLine={modalData.messageLine}
        title={
          <TextColored size={body28} type={modalData.color}>
            {modalData.title}
          </TextColored>
        }
        subtitle={
          <TextColored size={body32} bold type={modalData.color}>
            {modalData.subtitle}
          </TextColored>
        }
        message={
          <Text type="primary" size={body25} style={{ fontWeight : "600"}}>
            {modalData.message}
          </Text>
        }
        handleClose={handleCloseModalError}
        ButtonTry={modalData.buttonTry}
      />
    </>
  );
}

export default Resumen;
